"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgCampaignAnswered = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("path", { fill: "#D9EAF5", d: "M22.923 31a8 8 0 0 0 7.392-4.937 7.995 7.995 0 0 0-5.83-10.904 8 8 0 0 0-8.214 3.4 7.995 7.995 0 0 0 .995 10.099A8 8 0 0 0 22.923 31" }),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M19.479 14.69a9.003 9.003 0 0 1 12.272 6.557 8.99 8.99 0 0 1-3.827 9.237 9.004 9.004 0 0 1-11.365-1.12 8.996 8.996 0 0 1 2.92-14.674m4.81 1.45a7 7 0 0 0-7.187 2.975A6.996 6.996 0 0 0 22.923 30a7 7 0 0 0 6.468-4.32 6.996 6.996 0 0 0-5.102-9.542", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M27.088 19.883a1 1 0 0 1 .201 1.4l-3.868 5.165a2 2 0 0 1-3.014.213l-2-2a1 1 0 1 1 1.414-1.413l2 1.999h.002l3.865-5.163a1 1 0 0 1 1.4-.2M3 2a1 1 0 0 0-1 .999V22.99a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v3.997l4.364-3.273a1 1 0 0 1 1.2 1.599L5.6 31.788a1 1 0 0 1-1.6-.8V25.99H3a3 3 0 0 1-3-2.999V3A3 3 0 0 1 3 0h26a3 3 0 0 1 3 2.999v9.996a1 1 0 0 1-2 0V3a1 1 0 0 0-1-1z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M6 9.012a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1M6 14.01a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1M6 19.008a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1", clipRule: "evenodd" })));
exports.default = SvgCampaignAnswered;
